<template>
  <div>
    <v-card flat>
      <v-card-text>
        <pre>
ATLETICO DE MADRID 1982/1983	1 DVD
BARCELONA 1981/1982	2 DVDS
BARCELONA 1982/1983	2 DVDS
BARCELONA 1984/1985	2 DVDS
BARCELONA, REPORTAJE CAMPEON DE LIGA 1984/1985 (TVE)	1 DVD
BARCELONA 1985/1986	2 DVDS
BARCELONA 1986/1987	1 DVD
BARCELONA 1987/1998	2 DVDS
BARCELONA 1989/1990	2 DVDS
BARCELONA 1990/1991 (2ª VUELTA DE LIGA)	1 DVD
BARCELONA 1993/1994	2 DVDS
BARCELONA. RESUMENES VARIOS DE LOS FILIALES (AÑOS 80)	5 DVDS
C.F. EXTREMADURA 1994/1995	1 DVD
LAS PALMAS 1987/1988	1 DVD
VALENCIA 1980/1981	1 DVD
VALENCIA 1982/1983	2 DVDS
VALENCIA 1984/1985	2 DVDS
REAL MADRID 1983/1984	1 DVD
REAL MADRID 1986/1987	3 DVDS
REAL BETIS 1993/1994	1 DVD
REAL BETIS 1994/1995	1 DVD
REAL BETIS 1995/1996	2 DVDS
REAL BETIS 1996/1997	1 DVD
REAL BETIS 1997/1998	2 DVDS
REAL BETIS 1998/1999	1 DVD
REAL BETIS 1999/2000	1 DVD
REAL BETIS 2000/2001	1 DVD
REAL BETIS 2001/2002	1 DVD
REAL BETIS 2002/2003	2 DVDS
REAL BETIS 2003/2004	3 DVDS
REAL BETIS 2004/2005	3 DVDS
REAL BETIS 2005/2006	2 DVDS
REAL BETIS 2006/2007	1 DVD
REAL BETIS 2007/2008	1 DVD
REAL BETIS 2008/2009	1 DVD
REAL SOCIEDAD 1981/1982	2 DVDS
REAL SOCIEDAD 1982/1983	2 DVDS
REAL ZARAGOZA (DESDE 1980/1981 HASTA 1989/1990)	12 DVDS
SEVILLA 1983/1984	1 DVD
SEVILLA 1985/1986	1 DVD
SEVILLA 1986/1987	1 DVD
SEVILLA 1987/1988	2 DVDS
SEVILLA 1988/1989	2 DVDS
SEVILLA 1989/1990	2 DVDS
REAL BETIS GOLES 1993/1994	1 DVD
C.D. CASTELLON 1989/1990 + 1990/1991	2 DVDS
HELLAS VERONA 1984/1985	1 DVD
JUVENTUS 1985/1986	1 DVD
NAPOLES 1986/1987	1 DVD
MILAN 1987/1988	1 DVD
FUTBOL GENERAL 1983/1984	1 DVD
FUTBOL GENERAL 1984/1985	3 DVDS
FUTBOL GENERAL 1985/1986	7 DVS
FUTBOL GENERAL 1986/1987	4 DVDS
FUTBOL GENERAL 1987/1988	4 DVDS
FUTBOL GENERAL 1988/1989	2 DVDS
FUTBOL GENERAL 1989/1990	7 DVDS
FUTBOL GENERAL 1990/1991	3 DVDS
FUTBOL GENERAL 1994/1995	9 DVDS
FUTBOL GENERAL 1996/1997	14 DVDS
FUTBOL GENERAL 1997/1998	2 DVDS
FUTBOL GENERAL 1998/1999	12 DVDS
FUTBOL GENERAL 1999/2000	7 DVDS
RESUMENES VARIOS 1977/1978 (TVE)	1 DVD
RESUMENES LIGA 2ª DIVISION ESPAÑA 1998/1999	2 DVDS
FIEBRE MALDINI (2007/2008) (37 PROGRAMAS)	37 DVDS
FIEBRE MALDINI (2008/2009) (38 PROGRAMAS)	38 DVDS
FIEBRE MALDINI 2009/2010
EL TERCER TIEMPO (CANAL+) (2007/2008) (JORNADA 38)	1 DVD
EL TERCER TIEMPO (CANAL+) (2008/2009) (JORNADA 22)	1 DVD
EL TERCER TIEMPO (CANAL+) (2008/2009) (JORNADA 38)	1 DVD
ESTUDIO ESTADIO 1980/1981 (JORNADA 8)	1 DVD
U.D. LAS PALMAS (ASCENSO Y PERMANENCIA 2002)	1 DVD
1001 GOLES DEL BARCELONA	4 DVDS
JOHAN CRUYFF "EL PROFETA DEL GOL"	1 DVD
PAPA ETO'O (TV3 2005)	1 DVD
ASES DE LA LIGA (CANAL+) (GUARDIOLA, MESSI, XAVI, INIESTA)	1 DVD
RONALDINHO, LA SONRISA DEL FUTBOL	1 DVD
ROMARIO 1000 GOLES	1 DVD
CONEXIÓN VINTAGE, ESPAÑA 12-1 MALTA (TELEDEPORTE)	1 DVD
85 AÑOS DE HISTORIA DEL BARCELONA (1985)	1 DVD
DEPORTES CUATRO (30.11.2010) (BARCELONA 5-0 REAL MADRID) 	1 DVD
CAMPEONES "LA ROJA". TELE 5	1 DVD
GALA BALON DE ORO 2011 	1 DVD
RESUMENES CLASIFICACION EUROCOPA SUECIA 1992	1 DVD
TENGO UNA PREGUNTA PARA USTED, LUIS ARAGONES (TVE) 	1 DVD
MUNDIAL ESPAÑA 82 (25 AÑOS DESPUES) (CANAL+)	1 DVD
SONNY ANDERSON. GOLES EN EL BARCELONA 1997/1998 + 1998/1999	1 DVD
MINUT A MINUT (CANAL 9) (28.02.2010)	1 DVD
REPORTAJE ASCENSO LAS PALMAS A 1ª DIVISION 1984/1985 (TVE)	1 DVD
EL DIA DESPUES (CANAL+) (09.05.1994)	1 DVD
EL DIA DESPUES (CANAL+) (18.11.2002)	1 DVD
RESUMENES BENFICA (COPA DE EUROPA 1961/1962)	1 DVD
INFORME ROBINSON: MARADONA EN SEVILLA	1 DVD
ESTUDIO ESTADIO (19.12.1982)	1 DVD
ESTUDIO ESTADIO (28.03.2001)	1 DVD
ABC: DE SEGUNDA A EUROBETIS 1994/1995	1 DVD
EL CORREO DE ANDALUCIA: REAL BETIS 1994/1995	1 DVD
C.D. TENERIFE 1988/1989. UNA TEMPORADA INOLVIDABLE	1 DVD
        </pre>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
    name: "Summaries"
};
</script>

<style scoped>

</style>
